import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	fetchError: {
		id: 'jql-builder-basic-cascading-select.services.use-cascading-select-values-loader.fetch-error',
		defaultMessage: 'Something went wrong, please refresh and try again.',
		description: 'Error message for when the cascading select options could not be fetched',
	},
});
